import React, { useContext } from 'react';

import { LessonComponentType } from './LessonComponentType';

export interface LessonComponentContextModel {
  quillEditing: boolean;
  reattempt: boolean;
  /**
   * Value indicating whether the question has been answered, or
   * `null` if the question has not been answered at all.
   */
  correct: boolean | null;
  fullMark: boolean;
  componentType: LessonComponentType;
  userAnswer: string;
  showFeedback: boolean;
  answerSaved: boolean;
  isAnswerModified: boolean;
  isSurvey: boolean;
  handleAnswerSave: (status: boolean) => void;
  handleReattempt: () => void;
  handleSubmit: () => void;
  onBeforeClick: (componentKey: number) => void;
}

const LessonComponentContext = React.createContext<LessonComponentContextModel>(
  {
    quillEditing: false,
    reattempt: false,
    correct: null,
    fullMark: false,
    componentType: null,
    userAnswer: null,
    showFeedback: false,
    answerSaved: false,
    isAnswerModified: false,
    isSurvey: false,
    handleAnswerSave: () => {},
    handleReattempt: () => {},
    handleSubmit: () => {},
    onBeforeClick: () => {}
  }
);

export const useLessonComponentContext = () =>
  useContext(LessonComponentContext);

export const LessonComponentContextProvider = LessonComponentContext.Provider;
export const LessonComponentContextConsumer = LessonComponentContext.Consumer;
export default LessonComponentContext;
